<script lang="ts" module>
  import { Arrow, type ArrowRootProps } from "#lib/internal/components"
  import { styleToString } from "#lib/internal/helpers/style"
  import { getPopperContentContext } from "./PopperContent.svelte"
  import { getPopperRootContext } from "./PopperRoot.svelte"

  export type PopperArrowProps = ArrowRootProps
</script>

<script lang="ts">
  type Props = PopperArrowProps

  let { width = undefined, height = undefined, ...restProps }: Props = $props()

  const OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right",
  }

  const rootContext = getPopperRootContext()
  const contentContext = getPopperContentContext()

  $effect(() => {
    contentContext.arrowWidth = width ?? 0
    contentContext.arrowHeight = height ?? 0
  })

  const baseSide = $derived(OPPOSITE_SIDE[contentContext.placedSide])

  const style = $derived(
    styleToString({
      position: "absolute",
      left: contentContext.arrowX ? contentContext.arrowX + "px" : undefined,
      top: contentContext.arrowY ? contentContext.arrowY + "px" : undefined,
      [baseSide]: 0,
      "transform-origin": {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0",
      }[contentContext.placedSide],
      transform: {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: `rotate(180deg)`,
        left: "translateY(50%) rotate(-90deg) translateX(50%)",
      }[contentContext.placedSide],
      visibility: contentContext.shouldHideArrow ? "hidden" : "initial",
    })
  )

  let arrowElement: HTMLElement = $state()!

  $effect(() => {
    rootContext.arrow = arrowElement
  })
</script>

<span bind:this={arrowElement} {style}>
  <Arrow.Root
    {...restProps}
    style="{restProps.style ?? ''}; display:block"
    {width}
    {height}
  >
    <polygon
      points="0,0 30,0 15,10"
      class="fill-(--bg) stroke-(--border) stroke-2"
    />
    <line x1="0" y1="0" x2="30" y2="0" class="stroke-(--bg) stroke-2" />
  </Arrow.Root>
</span>
